import React, {useEffect, useState} from "react";
import { useParams, Link } from 'react-router-dom';
import Navigation from "../partials/Navigation";
import { getWithExpiry, setWithExpiry } from '../common';
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
//import configVars from "../config";
import CourseProgress from "../partials/CourseProgress";
import { useTranslation } from "react-i18next";
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import BoardInstructions from "../partials/BoardInstructions";
import { StickyContainer, Sticky } from 'react-sticky';
import BoardNav from "../partials/Boards/BoardNav";

const Topic = () => {

	const { lesson, topic, board_id } = useParams();
	const [ courseImage, setCourseImage] = useState('');
	//const [ lessonTitle, setLessonTitle] = useState('');
	const [ topicTitle, setTopicTitle] = useState('');
	const [ topicContent, setTopicContent] = useState('');
	const [ nextLink, setNextLink] = useState('');
	const [ prevLink, setPrevLink] = useState('');
	const [ topicID, setTopicID] = useState('');
	const [cookies] = useCookies(["sustainyou_user_jwt"]);
	const [ processing, setProcessing ] = useState(false);
	const [topicCompleted, setTopicCompleted] = useState( 'no' );
	const [courseProgress, setCourseProgress] = useState({});

	const [translation] = useTranslation("translations");

	useEffect(() => {

		const courseData = getWithExpiry(`sy_board_${board_id}_guides`);

		if ( ! courseData ) return;

		const lessonData = Object.keys(courseData).filter(l => courseData[l].name === lesson).map(l => courseData[l]);

		if ( ! lessonData[0] ) return;

		setCourseImage( lessonData[0].course_image );
		//setLessonTitle( lessonData[0].title );

		if ( lessonData[0].topics.length > 0 ) {

			const topicData = lessonData[0].topics.find(t => t.post_name === topic);
			
			if ( ! topicData ) return;

			const topicIndex = lessonData[0].topics.findIndex(t => t.post_name === topic);

			//let prevIndex;

			if ( (topicIndex + 1 ) < lessonData[0].topics.length ) {
				const nextIndex = topicIndex + 1;
				
				if ( lessonData[0].topics[nextIndex] ) {
					setNextLink( lessonData[0].topics[nextIndex].post_name );
				}
			} else {
				setNextLink('');
			}

			if ( (topicIndex - 1 ) >= 0 ) {
				const prevIndex = topicIndex - 1;

				if ( lessonData[0].topics[prevIndex] ) {
					setPrevLink( lessonData[0].topics[prevIndex].post_name );
				}
			} else {
				setPrevLink('');
			}
			
			// //console.log( nextIndex );
			// console.log( prevIndex );

			setTopicTitle( topicData.post_title );
			setTopicContent( topicData.post_content );
			setTopicID( topicData.ID );

			const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

			const isTopicCompleted = getWithExpiry( `topic_${topicData.ID}_${jwtDecoded.id}_completed` );

			if ( isTopicCompleted ) {

				if ( isTopicCompleted === 'yes' ) {
					setTopicCompleted( 'yes' );
				} else {
					setTopicCompleted( 'no' );
				}
				
			} else {

				(async () => {
				
					const response = await fetch(`https://learn.sustainchange.se/wp-json/sustainchangelms/v1/checktopiccomplete/?topicid=${topicData.ID}&userid=${jwtDecoded.id}`);
					
					const topicResponse = await response.json();
		
					if ( topicResponse ) {

						if ( topicResponse.success === true ) {
							setWithExpiry( `topic_${topicData.ID}_${jwtDecoded.id}_completed`, 'yes' );
							setTopicCompleted('yes');
						} else {
							setWithExpiry( `topic_${topicData.ID}_${jwtDecoded.id}_completed`, 'no' );
							setTopicCompleted('no');
						}
		
						//console.log( courseResponse );
		
					}
		
				})()

			}

		}

		//console.log( lessonData );

	}, [lesson, topic, cookies, board_id]);

	const getCourseProgress = async ( userID, topicID ) => {

		if ( !userID ) return;
		
		if ( !topicID ) return;

		const response = await fetch(`https://learn.sustainchange.se/wp-json/sustainchangelms/v1/getcourseprogress/?topicid=${topicID}&userid=${userID}`);
					
		const courseResponse = await response.json();

		if ( courseResponse && courseResponse.success === true ) {
			return courseResponse;
		}

	}

	const markTopicComplete = async ( userID, topicID ) => {

		if ( !userID ) return;
		
		if ( !topicID ) return;

		const response = await fetch(`https://learn.sustainchange.se/wp-json/sustainchangelms/v1/completetopic/?topicid=${topicID}&userid=${userID}`);
					
		const topicResponse = await response.json();

		if ( topicResponse && topicResponse.success === true ) {
			return topicResponse;
		}

	}

	const handleMarkComplete = () => {

		if ( ! cookies.sustainyou_user_jwt ) return;

		if ( ! topicID ) return;

		setProcessing( true );
		
		const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

		markTopicComplete( jwtDecoded.id, topicID ).then( (topicResponse) => {

			if ( topicResponse.success === true ) {
				setWithExpiry( `topic_${topicID}_${jwtDecoded.id}_completed`, 'yes' );
				setTopicCompleted('yes');

				getCourseProgress( jwtDecoded.id, topicID ).then ( (courseResponse) => {

					if ( courseResponse.success === true ) {
						setWithExpiry(`course_progress_${board_id}_${jwtDecoded.id}`, courseResponse.data );
						setCourseProgress( courseResponse.data );
					}

				});

			} else {
				setTopicCompleted('no');
			}

			setProcessing( false );

			//console.log( topicResponse );
		});

	}

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>{topicTitle}</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav />

				<div className="pt-5 pt-lg-0 page-content-inner">

					<BoardNav />

					{courseImage &&
							<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px', top: '40px'}}>
								<img src={courseImage} alt={topic} className="w-100" style={{objectFit: 'cover'}} />
								<div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column">
									<div className="flex-grow-1 d-flex align-items-center">
										{/* <h2 className="text-white text-center">{topicTitle}</h2> */}
									</div>
									<span className="text-white p-3 d-flex w-100 dark-overlay">
										<span className="text-white pe-3"><i className="fa fa-long-arrow-left" aria-hidden="true"></i></span>
										<Link to={`/board/${board_id}`} className="text-white">{translation("back_to_board")}</Link>
									</span>
								</div>
								<CourseProgress topic={topicID} progress={courseProgress} />
							</div>
						}

						<div className="px-3 pt-5 mb-6">
							
						<StickyContainer>
							<div className="mx-auto mt-4" style={{ maxWidth: "1400px" }}>
								<div className="row">
									<div className="col-12 col-lg-3">
										<Sticky disableCompensation>{({ style, isSticky }) => <div style={style} className={`${isSticky ? 'instructions-is-sticky' : ''}`}><BoardInstructions /></div>}</Sticky>
									</div>
									<div className="col-12 col-lg-9">
										<div className="row ">
											<div className="col-12 py-5 px-5">
												<div className="text-lg" dangerouslySetInnerHTML={{__html: topicContent}}></div>
											</div>
										</div>
										<div className="row">
											<div className="col-12 py-5 px-5">
												<div className="row">
													<div className="col-12 col-lg-4 mb-3 text-center text-lg-left">
														{prevLink &&
															<Link to={`/board/${board_id}/guide/${lesson}/${prevLink}`} className="text-white btn btn-halite-blue-light rounded-pill pe-lg-5">
																<i className="fa fa-angle-left" aria-hidden="true"></i>
																<span className="ps-4 d-inline-block">{translation("prev_topic")}</span>
															</Link>
														}
													</div>
													<div className="col-12 col-lg-4 text-center mb-3">
														{ topicCompleted === 'no' &&
															<button className="btn btn-halite-blue-light text-white rounded-pill ps-lg-5" onClick={ () => handleMarkComplete()}>
																<span className="pe-4 d-inline-block">{translation("mark_complete")}</span>
																{ !processing &&
																	<i className="fa fa-check" aria-hidden="true"></i>
																}
																{ processing &&
																	<div className="spinner-border text-light spinner-border-sm" role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>
																}

															</button>
														}

														{ topicCompleted === 'yes' &&
															<button type="button" className="btn btn-light-green-two text-white rounded-pill ps-lg-5 text-white">
																<span className="pe-4 d-inline-block">{translation("completed")}</span>
																<i className="fa fa-check" aria-hidden="true"></i>
															</button>
														}
													</div>
													<div className="col-12 col-lg-4 mb-3 text-center text-lg-left">
														{nextLink &&
															<Link to={`/board/${board_id}/guide/${lesson}/${nextLink}`} className="text-white btn btn-halite-blue-light rounded-pill ps-lg-5 float-lg-end">
																<span className="pe-4 d-inline-block">{translation("next_topic")}</span>
																<i className="fa fa-angle-right" aria-hidden="true"></i>
															</Link>
														}
													</div>
												</div>
												
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</StickyContainer>
					</div>
				</div>

			</div>
		</div>
	);
};

export default Topic;
